// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import zenscroll from 'zenscroll'

require('@/css/main.css')

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App },
  beforeMount: function () {
    setup()
    window.onresize = function (event) {
      setup()
    }
  }
})

function setup () {
  const computedFontSize = window.getComputedStyle(document.getElementById('app')).fontSize
  const v = (9 * parseInt(computedFontSize))
  zenscroll.setup(500, v)
}



// WEBPACK FOOTER //
// ./src/main.js